import { InjectableClass } from '@fino/lib-injection/index';

export class HotkeyService extends InjectableClass {
  constructor(envService, fdFormFieldsService) {
    'ngInject';
    super({ envService, fdFormFieldsService });
  }

  bindHotkeys(controller) {
    const { hotkeys, $scope } = controller;

    // Bind Hotkeys to the controllers scope (will automatically unbind
    // the hotkey when the scope is destroyed)
    const keyBinding = hotkeys.bindTo($scope).add({
      combo: 'return+return',
      description: 'Submit form',
      callback: () => controller.submit(),
    });

    // Make sure random data is not active in production
    if (!this.envService.isProduction()) {
      keyBinding.add({
        combo: 'ctrl+l',
        description: 'Toggle dev mode',
        callback: () => this.toggleDevMode(controller.form),
      });
    }
  }

  toggleDevMode(form) {
    this.fdFormFieldsService.toggleDevMode(form);
  }
}
